import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

type LanguageState = 'en' | 'ko';

const getInitialLanguage = (): LanguageState => {
  try {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage === 'en' || storedLanguage === 'ko') {
      return storedLanguage as LanguageState;
    }
  } catch (error) {
    console.error('Failed to access localStorage:', error);
  }
  return 'ko'; // default
};

const initialState: LanguageState = getInitialLanguage();

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      const newLanguage = action.payload;
      if (newLanguage === 'en' || newLanguage === 'ko') {
        localStorage.setItem('language', newLanguage);
        return newLanguage;
      }
      return state;
    }
  }
});

export const { setLanguage } = languageSlice.actions;
export const languageSelector = (state: RootState) => state.language;
export default languageSlice.reducer;
